module.exports = __webpack_public_path__ + "static/media/new6.de27e94b.png";